export default __webpack_public_path__ + "static/media/pause-button@2x.cc7f9c9e.png";